import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateRangeArgs, ReportDownloadArgs, ReportGeneratedArgs } from '../../../../models/reports';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PayrollTotals } from '../../../../models/client';
import { TimeframeOptions } from '../../report-enums';
import { CompaniesService } from '../../../../services/companies.service';
import {
  dateRangeComponentValidator,
  dateRangeRequired,
  dateRangeValidator
} from '../../../../utils/dateRangeValidator';
import moment from 'moment';

@Component({
  selector: 'lib-workers-compensation',
  templateUrl: './workers-compensation.component.html',
  styleUrls: ['./workers-compensation.component.css'],
  standalone: false
})
export class WorkersCompensationComponent implements OnInit {
  @Input()
  public clientCode: string;
  @Output()
  public reportGenerated = new EventEmitter<ReportGeneratedArgs>();
  @Output()
  public reportDownloadClicked = new EventEmitter<ReportDownloadArgs>();

  public reportGenerationForm: UntypedFormGroup;

  private readonly ENDPOINT = 'WorkersCompensation';

  private lastPayrollTotals: PayrollTotals;
  constructor(
    private fb: UntypedFormBuilder,
    private companiesService: CompaniesService
  ) {}

  ngOnInit(): void {
    const now = new Date();
    this.reportGenerationForm = this.fb.group({
      dateRange: this.fb.control({ start: new Date(now.getFullYear(), 0, 1), end: now }, [
        dateRangeRequired,
        dateRangeComponentValidator
      ])
    });
    this.companiesService.getLastPayrollTotals(this.clientCode, 0).subscribe(result => {
      this.lastPayrollTotals = result.length > 0 ? result[0] : null;
    });
  }
  public generateReport() {
    const args = this._getModel();
    this.reportGenerated.emit({ args, endpoint: this.ENDPOINT });
  }

  public downloadReport(format: string) {
    const args = this._getModel();
    const formattedStartDate = moment(args.StartDate).format('MM-DD-YYYY');
    const formattedEndDate = moment(args.EndDate).format('MM-DD-YYYY');
    const now = moment().format('MMDDYYYY');
    this.reportDownloadClicked.emit({
      args,
      endpoint: this.ENDPOINT,
      filename: `Workers Compensation_${this.clientCode}_${formattedStartDate} to ${formattedEndDate}_${now}.${format}`,
      format
    });
  }

  private _getModel() {
    const args: DateRangeArgs = {
      StartDate: this.reportGenerationForm.get('dateRange').value.start,
      EndDate: this.reportGenerationForm.get('dateRange').value.end
    };
    return args;
  }
}
